import { render } from "./PaiementPage.vue?vue&type=template&id=07f12ffa&ts=true"
import script from "./PaiementPage.vue?vue&type=script&lang=ts"
export * from "./PaiementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__